module.exports = __webpack_public_path__ + "static/img/px_4.db5f743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/px_4.jpg
// module id = stPo
// module chunks = 1